import axios from 'axios';
import type {
  AxiosInstance,
  AxiosResponse,
  AxiosRequestConfig,
  AxiosError,
} from 'axios';

export type OptionsConfig = {
  query: string;
  variables: { [index: string]: string | number };
} & AxiosRequestConfig;

class ApiClient {
  private baseUrl: string;
  public axios: AxiosInstance;
  constructor(url: string) {
    this.baseUrl = url;
    this.axios = axios.create({});
  }
  //AxiosResponse<TResult = unknown, TData = Record<string, unknown>>>
  //<TResult = unknown, TData = Record<string, unknown>>
  //Pass in a generic at time of calling function when type is complex and compiler doesn't pick it up
  //First Type is the Result of calling post, second
  public async post<TResult = unknown, TData = Record<string, unknown>>(
    body: TData,
    endpoint?: string,
    api_key?: string
  ): Promise<AxiosResponse<TResult, unknown> | undefined> {
    try {
      //Dynamically changing endpoints as needed;
      this.baseUrl = endpoint ?? this.baseUrl;
      const response: AxiosResponse<TResult> = await this.axios.post(
        this.baseUrl,
        body,
        {
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': api_key,
          },
        }
      );

      return response;
    } catch (e: unknown) {
      if (e instanceof Error) {
        throw e;
      }
    }
  }
}

export const api_client = new ApiClient('');

api_client.axios.interceptors.response.use(
  (response: AxiosResponse) => {
    return response.data;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

/*
api_client.post()
If you're passing in a gql query,
passing it gql doc with queries inside
then call gqlQueryParams(doc, variables: {variable1: value1})
*/
